import * as Yup from 'yup';

// this regex checks if at the end of the email there is a dot and at least one (non-dot) character after it
export const emailSchema = Yup.string()
    .email('Please enter a valid email.')
    .matches(/.*\.[^.]+$/, 'Please enter a valid email.');
